/**
 * Auth Service
 * 인증 관련 모든 API 호출을 중앙화
 */

import { apiClient } from './apiClient';

class AuthService {
  /**
   * 이메일/비밀번호로 로그인
   * @param {string} email - 사용자 이메일
   * @param {string} password - 사용자 비밀번호
   * @returns {Promise<{token: string, user: object}>}
   */
  async login(email, password) {
    return apiClient.post('/api/auth/login', { email, password });
  }

  /**
   * 회원가입
   * @param {{email: string, nickname: string, password: string}} userData - 회원가입 데이터
   * @returns {Promise<{token?: string, user?: object, requiresVerification?: boolean, message?: string}>}
   */
  async register(userData) {
    return apiClient.post('/api/auth/register', userData);
  }

  /**
   * 현재 로그인한 사용자 정보 조회 (토큰 검증)
   * @returns {Promise<{user: object}>}
   */
  async getMe() {
    return apiClient.get('/api/auth/me');
  }

  /**
   * 로그아웃 (서버에 토큰 무효화 요청)
   * @returns {Promise<void>}
   */
  async logout() {
    return apiClient.post('/api/auth/logout');
  }

  /**
   * 비밀번호 재설정 이메일 전송
   * @param {string} email - 비밀번호를 재설정할 이메일
   * @returns {Promise<{message: string}>}
   */
  async forgotPassword(email) {
    return apiClient.post('/api/auth/forgot-password', { email });
  }

  /**
   * 비밀번호 재설정 (토큰 + 새 비밀번호)
   * @param {string} token - 이메일로 전달받은 재설정 토큰
   * @param {string} password - 새 비밀번호
   * @returns {Promise<{message: string}>}
   */
  async resetPassword(token, password) {
    return apiClient.post('/api/auth/reset-password', { token, password });
  }

  /**
   * 인증 이메일 재전송
   * @param {string} email - 인증 이메일을 재전송할 이메일
   * @returns {Promise<{message: string}>}
   */
  async resendVerification(email) {
    return apiClient.post('/api/auth/resend-verification', { email });
  }
}

export const authService = new AuthService();
export default authService;
